import {
    REQUEST_PAGED_ARTICLES,
    RECEIVE_PAGED_ARTICLES,
    REQUEST_ARTICLE,
    RECEIVE_ARTICLE
} from "actions/article/article.actions";

export default (
    state = {
        articlesAreFetching: false,
        articles: undefined,
        singleArticleIsFetching: false,
        singleArticle: undefined
    },
    action
) => {
    switch (action.type) {
        case REQUEST_PAGED_ARTICLES:
            return { ...state, articlesAreFetching: true };
        case RECEIVE_PAGED_ARTICLES:
            return {
                ...state,
                articlesAreFetching: false,
                articles: action.articles
            };
        case REQUEST_ARTICLE:
            return { ...state, singleArticleIsFetching: true };
        case RECEIVE_ARTICLE:
            return {
                ...state,
                singleArticleIsFetching: false,
                singleArticle: action.singleArticle
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/articleReducer.js